export const downloadDBSBankCsvTemplate = ({
  date, // DDMMYYYY
  organisationId,
  organisationName,
  accountNumber,
  employees, // array of { type, value }
}) => {
  // HEADER
  const header = `H,${date},${organisationId},${organisationName},${accountNumber},1`;

  // RECORDS (multiple employees)
  const records = employees.flatMap((emp) => {
    const lines = [];

    if (emp.mobileNo) {
      lines.push(`E,M,${emp.mobileNo}`);
    }

    if (emp.uen) {
      lines.push(`E,U,${emp.accountNo}`);
    }

    if (emp.nric) {
      lines.push(`E,N,${emp.icno}`);
    }

    return lines;
  });

  // TRAILER (count of E records)
  const trailer = `T,${records.length}`;

  // FINAL FILE
  const fileContent = [header, ...records, trailer].join("\n");

  // DOWNLOAD
  const blob = new Blob([fileContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "Bank_File_Multi_Employee.csv";
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
